(() => {
  angular
    .module('gm.common.filters')
    .filter('gmNumberFlag', gmNumberFlagFilter);

  function gmNumberFlagFilter(
    $window
  ) {
    'ngInject';

    const phoneUtils = $window.libphonenumber.PhoneNumberUtil.getInstance();

    return (phone) => {
      try {
        const phoneObj = phoneUtils.parse(phone);
        return phoneUtils.getRegionCodeForNumber(phoneObj).toLowerCase();
      } catch (e) {
        return null;
      }
    };
  }
})();
